export default "__VITE_ASSET__Ci7LCphy__"